import { combineEpics } from 'redux-observable';
import Goals from './goals';
import Emails from './emails';
import Retirement from './retirement';
import Debt from './debt';
import Currency from './currency';
import Budget from './budget';
import Diagnostic from './diagnostic';
import Result from './result';

const epicList = [
  ...Goals,
  ...Emails,
  ...Retirement,
  ...Debt,
  ...Budget,
  ...Currency,
  ...Diagnostic,
  ...Result,
];

export default combineEpics(...epicList);
